import styled from "styled-components";
import NoTextSelectionStyles from "../../../common/styles/no-text-selection";

const GroupInviteSC = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .group-invite-holder {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 40px 50px;
        border-radius: 20px;
        ${NoTextSelectionStyles}
        background: linear-gradient(
            135deg,
            #f4f4f6 0%,
            #dfe7f3 40%,
            #d7f1ec 100%
        );
        width: 1200px;
        margin-top: 64px;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
        gap: 20px;
    }


    .tg-content h2 {
        margin: 0 0 8px 0;
        font-size: 28px;
        font-weight: 600;
        line-height: 40px;
        color: #1a1a1a;
    }

    .tg-content p {
        margin: 0;
        font-size: 18px;
        color: #555;
        width: 80%;
        line-height: 26px
    }

    .tg-button {
        display: flex;
        align-items: center;
        gap: 10px;
        background: #ffffff;
        border: none;
        justify-content: center;
        padding: 16px 0px;
        border-radius: 14px;
        font-size: 16px;
        font-weight: 500;
        cursor: pointer;
        width: 240px;
        box-shadow: 0 6px 15px rgba(0, 0, 0, 0.08);
        transition: all 0.3s ease;
    }

    .tg-button:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
    }

    .tg-icon {
        font-size: 18px;
    }

    @media (max-width: 768px) {
        .group-invite-holder {
            display: flex;
            flex-direction: column;
            padding: 12px;
            border-radius: 8px;
            margin: 8px;
            width: 100%;
            justify-content: center;
            align-items: center;
            gap: unset;
        }

        .tg-content h2 {
            margin: 8px 0 8px 0;
            width: 100%;
            font-size: 16px;
            font-weight: 600;
            line-height: 24px;
            text-align: center;
        }

        .tg-content p {
            margin: 0;
            font-size: 14px;
            width: 100%;
            line-height: 20px;
            text-align: justify;
            letter-spacing: 0.75px;
        }

        .tg-button {
            display: flex;
            width: 100%;
            gap: 8px;
            padding: 8px 0px;
            margin: 16px 0px;
            border-radius: 6px;
            font-size: 14px;
            -webkit-tap-highlight-color: transparent;
        }

        .tg-icon {
            font-size: 16px;
        }
    }
`;

export default GroupInviteSC;